import { fetchAPI } from '@quickbit/backoffice-core-frontend';
import {
  MerchantOrderFilters,
  Pagination,
  SortOptions,
  getOrders,
  MerchantOrderResponse,
} from 'tabs/api';

export const getOrderOverview = async ({
  pagination,
  filters: {
    createdFrom,
    createdTo,
    externalStatuses,
    orderOrPreviewId,
    referenceId,
    orderType,
    errors,
    abandonedAfterBuy,
    merchantId,
    hasFailedCallback,
  },
  sortOptions,
}: {
  pagination: Pagination;
  filters: Omit<MerchantOrderFilters, 'completedFrom' | 'completedTo'>;
  sortOptions?: SortOptions;
}): Promise<MerchantOrderResponse> => {
  const filters = {
    createdFrom,
    createdTo,
    orderOrPreviewId,
    referenceId,
    completedFrom: null,
    completedTo: null,
    abandonedAfterBuy,
    externalStatuses,
    orderType,
    errors,
    merchantId,
    hasFailedCallback,
  };
  return getOrders({ pagination, filters, sortOptions });
};

export type CallbackType =
  | 'CANCELLED'
  | 'NOTICED'
  | 'COMPLETED'
  | 'REFUNDED'
  | 'ERROR_OCCURRED';

export const simulateCallback = async ({
  orderId,
  type,
}: {
  orderId: string;
  type: CallbackType;
}) => {
  return fetchAPI(`v1/orders/${orderId}/simulate-callback`, {
    method: 'POST',
    body: {
      type,
    },
  });
};

export const resendCallback = async (orderId: string) => {
  return fetchAPI(`v1/orders/${orderId}/resend-callback`, {
    method: 'POST',
  });
};

export interface RefundOrderResponse {
  refundUrl?: string;
}

export const refundOrder = async (
  uuid: string,
  amount: number
): Promise<RefundOrderResponse> => {
  return fetchAPI<RefundOrderResponse>(`v1/orders/${uuid}/refund-order`, {
    method: 'POST',
    body: {
      amount,
    },
  });
};
